import React from "react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";

export const todayIso = () => new Date().toISOString().slice(0, 10);
export const yesterdayIso = () => { const d = new Date(); d.setDate(d.getDate() - 1); return d.toISOString().slice(0, 10); };

export function matchDate(itemDate, mode, custom) {
  if (!mode || mode === "all") return true;
  if (mode === "today") return itemDate === todayIso();
  if (mode === "yesterday") return itemDate === yesterdayIso();
  if (mode === "custom") return !custom || itemDate === custom;
  return true;
}

export default function DateFilterBar({ mode, setMode, custom, setCustom, testidPrefix = "date" }) {
  const btn = (val, label) => (
    <Button size="sm" variant={mode === val ? "default" : "outline"} onClick={() => setMode(val)}
      data-testid={`${testidPrefix}-${val}`} className="font-semibold">{label}</Button>
  );
  return (
    <div className="flex items-center gap-2 flex-wrap">
      {btn("all", "Tutte")}
      {btn("today", "Oggi")}
      {btn("yesterday", "Ieri")}
      <Input type="date" value={custom || ""} onChange={(e) => { setCustom(e.target.value); setMode(e.target.value ? "custom" : "all"); }}
        className="w-40 h-9" data-testid={`${testidPrefix}-custom`} />
    </div>
  );
}
